export const GET_COORDINATOR_RESIT_REGISTER_OPTIONS = 'GET_COORDINATOR_RESIT_REGISTER_OPTIONS';
export const GET_WINDOW_PERIOD_BY_EXAM_LEVEL = 'GET_WINDOW_PERIOD_BY_EXAM_LEVEL';
export const POST_CANDIDATE_SEARCH = 'POST_CANDIDATE_SEARCH';
export const GET_TEMPLATE_DOWNLOAD_URL = 'GET_TEMPLATE_DOWNLOAD_URL';
export const GET_PRE_SIGN_UPLOAD_URL = 'GET_PRE_SIGN_UPLOAD_URL';
export const POST_VALIDATE_UPLOAD_FILE = 'POST_VALIDATE_UPLOAD_FILE';
export const POST_UPLOAD_FILE_STATUS = 'POST_UPLOAD_FILE_STATUS';
export const GET_FILE_SCAN_STATUS = 'GET_FILE_SCAN_STATUS';
export const POST_RESIT_SUBJECT_FEE_SUMMARY = 'POST_RESIT_SUBJECT_FEE_SUMMARY';
export const POST_RESIT_GROUP_FEE = 'POST_RESIT_GROUP_FEE';
export const POST_RESIT_CANDIDATE_GROUP_FEE_SAVING = 'POST_RESIT_CANDIDATE_GROUP_FEE_SAVING';
export const GET_RESIT_SIMPLIFIED_PAYMENT_DETAIL = 'GET_SIMPLIFIED_PAYMENT_DETAIL';
export const POST_RESIT_COORDINATOR_DOWNLOAD_SUMMARY = 'POST_RESIT_COORDINATOR_DOWNLOAD_SUMMARY';
export const GET_RESIT_COORDINATOR_ACCESS_SUMMARY = 'GET_RESIT_COORDINATOR_ACCESS_SUMMARY';
export const GET_RESIT_APPLICATION_STATUS = 'GET_RESIT_APPLICATION_STATUS';
export const GET_RESIT_APPLICATION_DOWNLOAD_SUMMARY = 'GET_RESIT_APPLICATION_DOWNLOAD_SUMMARY';
export const GET_RESIT_CONFIGURATION = 'GET_RESIT_CONFIGURATION';
